import React from 'react';
import { AonDialog } from '../../components/core/AonDialog';
import { UuiLogo } from '@aonunited/react';
import { AonButton } from '../../components/core/AonButton';
import { BUTTON_VARIANT } from '../../components/core/AonButton/consts';
import './S&PDialog.scss';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var SPDialog = function (props) {
    var textContent = {
        Stable: "Rating is not likely to change over the next 6-24 months.",
        Negative: "Rating may be lowered over the next 6-24 months.",
        Positive: "Rating may be raised over the next 6-24 months."
    };
    var Footer = function () {
        return React.createElement("div", null,
            React.createElement(AonButton, { style: { marginInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: props.onClickClose }, "Close"));
    };
    var Body = function () {
        return React.createElement("div", { className: 'sp-body' },
            React.createElement("h3", null, "S&P Outlook Definitions"),
            React.createElement("div", { className: 'SP-text-container' }, Object.keys(textContent).map(function (label) { return (React.createElement("div", { className: 'SP-text-wrapper' },
                React.createElement("span", { className: 'label' },
                    label,
                    ":"),
                React.createElement("div", { className: 'text' }, textContent[label]))); })));
    };
    return (React.createElement(AonDialog, { dismissOnEsc: false, dismissOnOverlay: false, opened: props.showDialog, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
            React.createElement("div", { className: 'logo_about_dialog' },
                React.createElement(UuiLogo, { onClick: function () { } })),
            React.createElement(FontAwesomeIcon, { className: 'text-icon', onClick: props.onClickClose, icon: faClose })), body: React.createElement(Body, null), footer: React.createElement(Footer, null) }));
};
export default SPDialog;
